import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=13eda189&scoped=true&"
import script from "./Permissions.vue?vue&type=script&lang=js&"
export * from "./Permissions.vue?vue&type=script&lang=js&"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=13eda189&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eda189",
  null
  
)

export default component.exports